export const colors = {
  // ===== BASE COLORS =====
  white: '#FFFFFF',
  red: '#FF0000',
  error: '#F41148',
  blue: '#0099FF',
  black: '#000000',
  orange: '#FF8C00',
  green: '#00FF00',
  natural: '#F5F5F5',
  secondary: '#999999',
  gray: '#BFBFBF',
  lightGray: '#D9D9D9',
  divider: '#EDECF3',
  disabled: 'rgba(21, 17, 49, 0.17)',
  transparent: 'transparent',
  overlay: 'rgba(0, 0, 0, 0.45)',

  // ===== SEMANTIC COLORS =====

  border: {
    focus: '#0099FF',
  },
  // ===== BUTTON COLORS =====
  primaryBg: '#151131',
  primaryText: '#FFFFFF',
  primaryHover: '#0056B3',
  primaryActive: '#709CA8',
  primaryFocus: '#21825B',

  secondaryBg: '#F6F6F6',
  secondaryText: '#000000',
  secondaryHover: '#E2E6EA',
  secondaryBorder: '#DDD',

  infoBg: '#0099FF',
  infoText: '#FFFFFF',
  infoHover: '#0056B3',

  // ===== ROLE COLORS =====
  partner: '#0044AB',
  partnerText: '#133B76',
  player: '#FFB422',
  playerText: '#E29909',

  // ===== CUSTOM =====
  headerBackground: '#A7BEFF',
  boxShadow: 'rgba(92, 64, 255, 0.08)',
  inputBorder: '#C7C4DC',
  placeholder: '#BBB9CD',
  link: '#6A677D',
  loginBannerTitle: 'rgba(21, 17, 49, 0.3)',
  customerServiceHQ: '#FFD400',
  customerServiceEU: '#FE81FB',
  listHeaderBg: '#E5ECFF',
  listHeaderText: '#616771',
};
